/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type CreateReceiptsGlobals = {
  /**
   * Specify an API version.
   *
   * @remarks
   *
   * API versioning follows the format `vYYYY.QQ.BB`, where
   *   - `YYYY` is the year
   *   - `QQ` is the two-digit month for the first month of the quarter (e.g., 01, 04, 07, 10)
   *   - `BB` is the build number, starting at `.01`, for subsequent builds in the same quarter.
   *     - For example, `v2024.01.00` is the initial release of the first quarter of 2024.
   *
   * The `latest` version represents the most recent development state. It may include breaking changes and should be treated as a beta release.
   * When no version is specified, the API defaults to `v2024.01.00`.
   */
  xMoovVersion?: string | undefined;
};

export type CreateReceiptsResponse = {
  headers: { [k: string]: Array<string> };
  result: Array<components.ReceiptResponse>;
};

/** @internal */
export const CreateReceiptsGlobals$inboundSchema: z.ZodType<
  CreateReceiptsGlobals,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-Moov-Version": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-Moov-Version": "xMoovVersion",
  });
});
/** @internal */
export type CreateReceiptsGlobals$Outbound = {
  "X-Moov-Version"?: string | undefined;
};

/** @internal */
export const CreateReceiptsGlobals$outboundSchema: z.ZodType<
  CreateReceiptsGlobals$Outbound,
  z.ZodTypeDef,
  CreateReceiptsGlobals
> = z.object({
  xMoovVersion: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xMoovVersion: "X-Moov-Version",
  });
});

export function createReceiptsGlobalsToJSON(
  createReceiptsGlobals: CreateReceiptsGlobals,
): string {
  return JSON.stringify(
    CreateReceiptsGlobals$outboundSchema.parse(createReceiptsGlobals),
  );
}
export function createReceiptsGlobalsFromJSON(
  jsonString: string,
): SafeParseResult<CreateReceiptsGlobals, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateReceiptsGlobals$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateReceiptsGlobals' from JSON`,
  );
}

/** @internal */
export const CreateReceiptsResponse$inboundSchema: z.ZodType<
  CreateReceiptsResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  Headers: z.record(z.array(z.string())).default({}),
  Result: z.array(components.ReceiptResponse$inboundSchema),
}).transform((v) => {
  return remap$(v, {
    "Headers": "headers",
    "Result": "result",
  });
});
/** @internal */
export type CreateReceiptsResponse$Outbound = {
  Headers: { [k: string]: Array<string> };
  Result: Array<components.ReceiptResponse$Outbound>;
};

/** @internal */
export const CreateReceiptsResponse$outboundSchema: z.ZodType<
  CreateReceiptsResponse$Outbound,
  z.ZodTypeDef,
  CreateReceiptsResponse
> = z.object({
  headers: z.record(z.array(z.string())),
  result: z.array(components.ReceiptResponse$outboundSchema),
}).transform((v) => {
  return remap$(v, {
    headers: "Headers",
    result: "Result",
  });
});

export function createReceiptsResponseToJSON(
  createReceiptsResponse: CreateReceiptsResponse,
): string {
  return JSON.stringify(
    CreateReceiptsResponse$outboundSchema.parse(createReceiptsResponse),
  );
}
export function createReceiptsResponseFromJSON(
  jsonString: string,
): SafeParseResult<CreateReceiptsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateReceiptsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateReceiptsResponse' from JSON`,
  );
}
